import {
  Row,
  Col,
  Typography,
  Form,
  Space,
  Select,
  DatePicker,
  Button,
  Table,
  Tooltip,
  Divider,
  Modal,
} from "antd";
import moment from "moment";
import axios from "axios";
import { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import CreateLogs from "./CreateLogs";
import EditLogs from "./EditLogs";
import CreateDeduction from "./CreateDeduction";
import EditDeduction from "./EditDeduction";
import CreateOvertime from "./CreateOvertime";
import EditOvertime from "./EditOvertime";
import _ from "lodash";

const CreatePayroll = ({ employeeList, close, getPayrollList }) => {
  const [loading, setLoading] = useState(false);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [logList, setLogList] = useState({ data: [], ready: false });
  const [deductionList, setDeductionList] = useState({
    data: [],
    ready: false,
  });
  const [overtimeList, setOvertimeList] = useState({
    data: [],
    ready: false,
  });
  const [employeeInfo, setEmployeeInfo] = useState({ data: [], ready: false });
  const [activeInfo, setActiveInfo] = useState(null);
  const [lateUnderInfo, setLateUnderInfo] = useState(null);
  const [addLogDiag, setAddLogDiag] = useState(false);
  const [editLogDiag, setEditLogDiag] = useState(false);
  const [selectedData, setSelectedData] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(null);
  const [totalOvertime, setTotalOvertime] = useState(null);
  const [totalDeduction, setTotalDeduction] = useState(null);
  const [addDeductionDiag, setAddDeductionDiag] = useState(false);
  const [addOvertimeDiag, setAddOvertimeDiag] = useState(false);
  //deduction
  const [selectedDeduction, setSelectedDeduction] = useState(false);
  const [editDeductionDiag, setEditDeductionDiag] = useState(false);
  const [deleteDeduction, setDeleteDeduction] = useState(false);

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteLog, setDeleteLog] = useState(false);
  const [confirmAndSave, setConfirmAndSave] = useState(false);
  //overtime
  const [selectedOvertime, setSelectedOvertime] = useState(false);
  const [editOvertimeDiag, setEditOvertimeDiag] = useState(false);
  const [deleteOvertime, setDeleteOvertime] = useState(false);

  //govt contribution
  const [addGovtContribDiag, setAddGovtContribDiag] = useState(false);

  const handleGetOvertimes = () => {
    var params = {
      date_from: selectedDateFrom,
      date_to: selectedDateTo,
      merchant_id: userData.data.id,
      user_id: selectedEmployee,
    };
    // setLoading(true);
    axios
      .get("user/merchant/get/employee-overtime", { params })
      .then((response) => {
        const data = response.data;
        // rerunNotif("success", "Fetched deduction successful.");
        setTimeout(() => {
          setOvertimeList({ data, ready: true });
          setTotalOvertime(calculateOT(data));
          // setActiveInfo(countLogs(data));
          // setLateUnderInfo(countLateUnder(data));
          // setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoading(false);
      });
  };

  const handleGetDeductions = () => {
    var params = {
      date_from: selectedDateFrom,
      date_to: selectedDateTo,
      merchant_id: userData.data.id,
      user_id: selectedEmployee,
    };
    // setLoading(true);
    axios
      .get("user/merchant/get/employee-deductions", { params })
      .then((response) => {
        const data = response.data;
        // rerunNotif("success", "Fetched deduction successful.");
        setTimeout(() => {
          setDeductionList({ data, ready: true });
          setTotalDeduction(calculate(data));
          // setActiveInfo(countLogs(data));
          // setLateUnderInfo(countLateUnder(data));
          // setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoading(false);
      });
  };

  function calculate(data) {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += data[i].amount * 1;
    }
    return total;
  }

  function calculateOT(data) {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].ot_minutes) * parseFloat(data[i].ot_per_minute);
    }
    return total;
  }

  const handleGetRecord = () => {
    var params = {
      date_from: selectedDateFrom,
      date_to: selectedDateTo,
      user_id: userData.data.id,
      employee: selectedEmployee,
    };
    setLoading(true);
    axios
      .get("user/merchant/get/employee-logs", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Fetched record successful.");
        setTimeout(() => {
          const res = _.chain(response.data)
            .groupBy((g) => g.current_date)
            .map((value, key) => ({
              current_date: key,
              data: value,
              day_status: value[0].day_status,
              day_sub_status: value[0].day_sub_status,
            }))
            .value();
          // console.log("res: ", res);

          setActiveInfo(countLogs(res));
          setLogList({ data: res, ready: true });
          setLateUnderInfo(countLateUnder(data));
          setLoading(false);
          handleGetDeductions();
          handleGetOvertimes();
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        setLoading(false);
      });
  };

  const handleGetEmployeeInfo = (employee) => {
    var params = {
      employee,
    };
    axios
      .get("user/merchant/get/employee-info", { params })
      .then((response) => {
        const data = response.data;
        // console.log("EMPLOYEE INFO: ", data);
        setTimeout(() => {
          setEmployeeInfo({ data, ready: true });
          setLoading(false);
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        setLoading(false);
      });
  };

  function countLogs(data) {
    var active = 0;
    var absent = 0;
    for (let i = 0; i < data.length; i++) {
      if (
        data[i].day_status === "active" &&
        data[i].day_sub_status === "present"
      ) {
        active += 1;
      }
      if (
        data[i].day_status === "active" &&
        data[i].day_sub_status === "absent"
      ) {
        absent += 1;
      }
    }
    return { active, absent };
  }

  function countLateUnder(data) {
    var late = 0;
    var under = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].day_sub_status === "present") {
        const startLateMinutes = timeToMinutes(data[i].current_time_in);
        const endLateMinutes = timeToMinutes(data[i].schedule_time_in);
        const differenceLate = startLateMinutes - endLateMinutes;
        late += parseInt(differenceLate <= 0 ? 0 : differenceLate.toFixed(0));

        if (data[i].current_time_out !== null) {
          const startUnderMinutes = timeToMinutes(data[i].current_time_out);
          const endUnderMinutes = timeToMinutes(data[i].schedule_time_out);
          const differenceUnder = endUnderMinutes - startUnderMinutes;

          under += parseInt(
            differenceUnder <= 0 ? 0 : differenceUnder.toFixed(0)
          );
        }
      }
    }
    return { late, under };
  }

  function calculateToMinutesLate(start, end) {
    const startMinutes = timeToMinutes(start);
    const endMinutes = timeToMinutes(end);
    const difference = startMinutes - endMinutes;

    if (difference <= 0) {
      return null;
    } else {
      return `${difference.toFixed(0)} mins`;
    }
  }

  function calculateToMinutesUndertime(start, end) {
    const startMinutes = timeToMinutes(start);
    const endMinutes = timeToMinutes(end);
    const difference = endMinutes - startMinutes;

    if (difference <= 0) {
      return null;
    } else {
      return `${difference.toFixed(0)} mins`;
    }
  }

  function timeToMinutes(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    return hours * 60 + minutes + seconds / 60;
  }

  const handleDeductionOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDeduction(false);
      setConfirmLoading(false);
      handleDeleteDeduction();
    }, 2000);
  };

  const handleDeleteDeduction = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "id",
      selectedDeduction !== null ? selectedDeduction.id : ""
    );
    axios
      .post("user/merchant/delete/employee-deduction", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Deduction is deleted successfully.");
          setTimeout(() => {
            handleGetDeductions();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoading(false);
      });
  };

  const handleLogOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteLog(false);
      setConfirmLoading(false);
      handleDeleteLog();
    }, 2000);
  };

  const handleDeleteLog = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    axios
      .post("user/merchant/delete/employee-log", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Log is deleted successfully.");
          setTimeout(() => {
            handleGetRecord();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoading(false);
      });
  };

  const handleOvertimeOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteOvertime(false);
      setConfirmLoading(false);
      handleDeleteOvertime();
    }, 2000);
  };

  const handleDeleteOvertime = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedOvertime !== null ? selectedOvertime.id : "");
    axios
      .post("user/merchant/delete/employee-overtime", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Overtime is deleted successfully.");
          setTimeout(() => {
            handleGetOvertimes();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoading(false);
      });
  };

  const handleAddGovtContribution = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setAddGovtContribDiag(false);
      setConfirmLoading(false);
      handleConfirmAddGovContrib();
    }, 2000);
  };

  // console.log("EMPLOYEE INFO: ", employeeInfo);

  const handleConfirmAddGovContrib = () => {
    const formdata = new FormData();
    formdata.append("merchant_id", userData.data.id);
    formdata.append(
      "user_id",
      employeeInfo.ready && employeeInfo.data[0].user_id
    );
    formdata.append("date_from", selectedDateFrom);
    formdata.append("date_to", selectedDateTo);
    formdata.append(
      "capital",
      employeeInfo.ready && employeeInfo.data[0].salary_sched === "daily"
        ? parseFloat(employeeInfo.data[0].daily_amount) * 26
        : parseFloat(employeeInfo.data[0].monthly_amount)
    );

    // formdata.append("id", selectedOvertime !== null ? selectedOvertime.id : "");
    axios
      .post("user/merchant/create/bulk-employee-govt-contrib", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Govt Contribution is added successfully.");
          setTimeout(() => {
            handleGetDeductions();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoading(false);
      });
  };

  const handleConfirmAndSaveOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setConfirmAndSave(false);
      setConfirmLoading(false);
      handleConfirmAndSaveToPayroll();
    }, 2000);
  };

  const handleConfirmAndSaveToPayroll = () => {
    const formdata = new FormData();
    formdata.append("merchant_id", userData.data.id);
    formdata.append(
      "user_id",
      employeeInfo.ready && employeeInfo.data[0].user_id
    );
    formdata.append(
      "salary_sched",
      employeeInfo.ready && employeeInfo.data[0].salary_sched !== null
        ? employeeInfo.data[0].salary_sched
        : ""
    );
    formdata.append(
      "salary_pay_count",
      employeeInfo.ready && employeeInfo.data[0].salary_pay_count !== null
        ? employeeInfo.data[0].salary_pay_count
        : ""
    );
    formdata.append(
      "daily_amount",
      employeeInfo.ready && employeeInfo.data[0].daily_amount !== null
        ? employeeInfo.data[0].daily_amount
        : ""
    );
    formdata.append(
      "monthly_amount",
      employeeInfo.ready && employeeInfo.data[0].monthly_amount !== null
        ? employeeInfo.data[0].monthly_amount
        : ""
    );
    formdata.append("date_from", selectedDateFrom);
    formdata.append("date_to", selectedDateTo);

    //qweqweqwe
    formdata.append("present_count", activeInfo.active);
    formdata.append("absent_count", activeInfo.absent);
    formdata.append("late_mins", lateUnderInfo.late);
    formdata.append("under_mins", lateUnderInfo.under);
    formdata.append(
      "per_hour",
      employeeInfo.data[0].salary_sched === "daily"
        ? employeeInfo.data[0].daily_amount / 8
        : employeeInfo.data[0].monthly_amount /
            employeeInfo.data[0].salary_pay_count /
            (activeInfo.absent + activeInfo.active) /
            8
    );
    formdata.append(
      "per_mins",
      employeeInfo.data[0].salary_sched === "daily"
        ? employeeInfo.data[0].daily_amount / 8 / 60
        : employeeInfo.data[0].monthly_amount /
            employeeInfo.data[0].salary_pay_count /
            (activeInfo.absent + activeInfo.active) /
            8 /
            60
    );
    formdata.append(
      "basic_pay",
      employeeInfo.data[0].salary_sched === "daily"
        ? employeeInfo.data[0].daily_amount
        : employeeInfo.data[0].monthly_amount /
            employeeInfo.data[0].salary_pay_count /
            (activeInfo.absent + activeInfo.active)
    );
    formdata.append("total_deductions", totalDeduction);
    formdata.append("total_overtime", totalOvertime);

    formdata.append(
      "salary",
      employeeInfo.data[0].salary_sched === "daily"
        ? employeeInfo.data[0].daily_amount * activeInfo.active
        : (employeeInfo.data[0].monthly_amount /
            employeeInfo.data[0].salary_pay_count /
            (activeInfo.absent + activeInfo.active)) *
            activeInfo.active
    );
    formdata.append(
      "gross_salary",
      employeeInfo.data[0].salary_sched === "daily"
        ? employeeInfo.data[0].daily_amount * activeInfo.active -
            (employeeInfo.data[0].daily_amount / 8 / 60) *
              (lateUnderInfo.late + lateUnderInfo.under) -
            totalDeduction +
            totalOvertime
        : (employeeInfo.data[0].monthly_amount /
            employeeInfo.data[0].salary_pay_count /
            (activeInfo.absent + activeInfo.active)) *
            activeInfo.active -
            (employeeInfo.data[0].monthly_amount /
              employeeInfo.data[0].salary_pay_count /
              (activeInfo.absent + activeInfo.active) /
              8 /
              60) *
              (lateUnderInfo.late + lateUnderInfo.under) -
            totalDeduction +
            totalOvertime
    );

    axios
      .post("user/merchant/create/employee-payroll", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Payroll is created successfully.");
          setTimeout(() => {
            close();
            getPayrollList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoading(false);
      });
  };

  //calculation LATE & UNDERTIME
  function getDailyLateAndUndertime(daily_amount, late, under) {
    const dailyAmount = parseFloat(daily_amount) / 8 / 60;
    // console.log("DAILY: ", dailyAmount);
    const lateUnder = late + under;
    const total = dailyAmount * lateUnder;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getMonthlyLateAndUndertime(
    monthly_amount,
    salary_pay_count,
    absent,
    active,
    late,
    under
  ) {
    const absentActive = absent + active;
    const lateUnder = late + under;
    const dailyAmount =
      parseFloat(monthly_amount) / parseFloat(salary_pay_count) / absentActive;
    const subtotal = dailyAmount / 8 / 60;
    const total = subtotal * lateUnder;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  //calculate PER HOUR
  function getDailyPerHour(daily_amount) {
    const dailyAmount = parseFloat(daily_amount);
    const total = dailyAmount / 8;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getMonthlyPerHour(monthly_amount, salary_pay_count, absent, active) {
    const absentActive = absent + active;
    const dailyAmount =
      parseFloat(monthly_amount) / parseFloat(salary_pay_count) / absentActive;
    const total = dailyAmount / 8;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  //calculate PER MINUTE
  function getDailyPerMinute(daily_amount) {
    const dailyAmount = parseFloat(daily_amount);
    const total = dailyAmount / 8 / 60;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getMonthlyPerMinute(
    monthly_amount,
    salary_pay_count,
    absent,
    active
  ) {
    const absentActive = absent + active;
    const dailyAmount =
      parseFloat(monthly_amount) / parseFloat(salary_pay_count) / absentActive;
    const total = dailyAmount / 8 / 60;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  //calculate BASIC PAY
  function getDailyBasicPay(daily_amount) {
    const dailyAmount = parseFloat(daily_amount);
    const total = dailyAmount;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getMonthlyBasicPay(
    monthly_amount,
    salary_pay_count,
    absent,
    active
  ) {
    const absentActive = absent + active;
    const dailyAmount =
      parseFloat(monthly_amount) / parseFloat(salary_pay_count) / absentActive;
    const total = dailyAmount;
    return parseFloat(total).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={16}>
        <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
          <div style={{ padding: 10 }}>
            <div
              style={{
                marginBottom: 10,
                display: "flex",
                alignItems: "center",
                gap: 5,
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Typography style={{ fontWeight: "bold", fontSize: 20 }}>
                  Creating Payroll
                </Typography>
              </div>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                // size="small"
                onClick={() => setAddOvertimeDiag(true)}
                disabled={!employeeInfo.ready && employeeInfo.data.length < 1}
              >
                Add Overtime
              </Button>
              <Button
                // type="dashed"
                icon={<PlusOutlined />}
                // size="small"
                onClick={() => setAddDeductionDiag(true)}
                disabled={!employeeInfo.ready && employeeInfo.data.length < 1}
              >
                Add Deduction
              </Button>
              <Button
                // type="dashed"
                icon={<PlusOutlined />}
                // size="small"
                onClick={() => setAddGovtContribDiag(true)}
                disabled={!employeeInfo.ready && employeeInfo.data.length < 1}
              >
                Add Govt
              </Button>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                // size="small"
                onClick={() => setAddLogDiag(true)}
                disabled={!employeeInfo.ready && employeeInfo.data.length < 1}
              >
                Add Log
              </Button>
            </div>
            <Divider />
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "bold",
                color: "blue",
                marginBottom: 10,
              }}
            >
              ATTENDANCE LOG
            </Typography>
            <div style={{ overflowX: "auto" }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: "calc(100% / 7)",
                    fontSize: 11,
                    fontWeight: "bold",
                  }}
                >
                  <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                    Date
                  </p>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    // flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Timein - (Sched)
                    </p>
                  </div>
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Timeout - (Sched)
                    </p>
                  </div>
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Late
                    </p>
                  </div>
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Under Time
                    </p>
                  </div>
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Status
                    </p>
                  </div>
                  <div
                    style={{
                      width: "calc(100% / 6)",
                      fontSize: 11,
                      fontWeight: "bold",
                    }}
                  >
                    <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                      Action
                    </p>
                  </div>
                </div>
              </div>
              <Divider />

              {/* EMPLOYEE LOGS */}
              {logList.ready && logList.data.length > 0 && (
                <>
                  {logList.data.map((data, index) => (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        padding: 5,
                        borderBottom: "1px solid #e5e5e5",
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                        }}
                      >
                        <div
                          style={{
                            width: "calc(100% / 7)",
                            fontSize: 11,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              textAlign: "center",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            {moment(data.current_date).format("ll")}
                          </p>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {data.data.length > 0 &&
                            data.data.map((data2, index2) => (
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  border:
                                    selectedData.id === data2.id
                                      ? "2px solid red"
                                      : "none",
                                }}
                                key={index2}
                              >
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {data2.current_time_in !== null ? (
                                      <>
                                        {`${moment(
                                          data2.current_time_in,
                                          "HH:mm:ss"
                                        ).format("hh:mm A")} - (${moment(
                                          data2.schedule_time_in,
                                          "HH:mm:ss"
                                        ).format("hh:mm A")})`}
                                      </>
                                    ) : (
                                      "---:---:---"
                                    )}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {data2.current_time_out !== null ? (
                                      <>
                                        {`${moment(
                                          data2.current_time_out,
                                          "HH:mm:ss"
                                        ).format("hh:mm A")} - (${moment(
                                          data2.schedule_time_out,
                                          "HH:mm:ss"
                                        ).format("hh:mm A")})`}
                                      </>
                                    ) : (
                                      "---:---:---"
                                    )}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {data2.current_time_in !== null &&
                                      calculateToMinutesLate(
                                        data2.current_time_in,
                                        data2.schedule_time_in
                                      )}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    {data2.current_time_out !== null &&
                                      calculateToMinutesUndertime(
                                        data2.current_time_out,
                                        data2.schedule_time_out
                                      )}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                      textTransform: "capitalize",
                                      color:
                                        data2.day_sub_status === "present"
                                          ? "green"
                                          : "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {data2.day_sub_status}
                                  </p>
                                </div>
                                <div
                                  style={{
                                    width: "calc(100% / 6)",
                                    fontSize: 11,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  >
                                    <Button
                                      type="dashed"
                                      shape="circle"
                                      onClick={() => {
                                        setSelectedData(data2);
                                        setEditLogDiag(true);
                                      }}
                                      icon={<EditOutlined />}
                                      size="small"
                                      style={{
                                        marginRight: 5,
                                        // data2.day_sub_status === "absent" ? 5 : 0,
                                      }}
                                    />

                                    {/* {data2.day_sub_status === "absent" && ( */}
                                    <Button
                                      type="dashed"
                                      shape="circle"
                                      onClick={() => {
                                        setSelectedData(data2);
                                        setDeleteLog(true);
                                      }}
                                      icon={<DeleteOutlined />}
                                      size="small"
                                    />
                                    {/* )} */}
                                  </p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
              <Divider />

              {/* DEDUCTIONS */}
              {deductionList.ready && deductionList.data.length > 0 && (
                <>
                  <Typography
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "blue",
                      marginBottom: 10,
                    }}
                  >
                    DEDUCTIONS
                  </Typography>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Description
                      </p>
                    </div>
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Amount
                      </p>
                    </div>
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Action
                      </p>
                    </div>
                  </div>
                  <Divider />
                  {deductionList.data.map((data, index) => (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        border:
                          selectedDeduction.id === data.id
                            ? "2px solid red"
                            : "none",
                        padding: 5,
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          {data.description}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          {parseFloat(data.amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          <Button
                            type="dashed"
                            shape="circle"
                            onClick={() => {
                              setSelectedDeduction(data);
                              setEditDeductionDiag(true);
                            }}
                            icon={<EditOutlined />}
                            size="small"
                            style={{ marginRight: 5 }}
                          />

                          <Button
                            type="dashed"
                            shape="circle"
                            onClick={() => {
                              setSelectedDeduction(data);
                              setDeleteDeduction(true);
                            }}
                            icon={<DeleteOutlined />}
                            size="small"
                          />
                        </p>
                      </div>
                    </div>
                  ))}
                </>
              )}
              <Divider />

              {/* OVERTIME */}
              {overtimeList.ready && overtimeList.data.length > 0 && (
                <>
                  <Typography
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: "blue",
                      marginBottom: 10,
                    }}
                  >
                    OVER TIME
                  </Typography>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Description
                      </p>
                    </div>
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Amount
                      </p>
                    </div>
                    <div
                      style={{
                        width: "calc(100% / 3)",
                        fontSize: 11,
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ textAlign: "center", padding: 0, margin: 0 }}>
                        Action
                      </p>
                    </div>
                  </div>
                  <Divider />
                  {overtimeList.data.map((data, index) => (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        border:
                          selectedOvertime.id === data.id
                            ? "2px solid red"
                            : "none",
                        padding: 5,
                      }}
                      key={index}
                    >
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          {`
                          ${moment(data.ot_date).format("ll")} 
                          (${moment(data.ot_time_in, "HH:mm:ss").format(
                            "hh:mm A"
                          )} - ${moment(data.ot_time_out, "HH:mm:ss").format(
                            "hh:mm A"
                          )})`}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          {parseFloat(
                            parseFloat(data.ot_minutes) *
                              parseFloat(data.ot_per_minute)
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </p>
                      </div>
                      <div
                        style={{
                          width: "calc(100% / 3)",
                          fontSize: 11,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{ textAlign: "center", padding: 0, margin: 0 }}
                        >
                          <Button
                            type="dashed"
                            shape="circle"
                            onClick={() => {
                              setSelectedOvertime(data);
                              setEditOvertimeDiag(true);
                            }}
                            icon={<EditOutlined />}
                            size="small"
                            style={{ marginRight: 5 }}
                          />

                          <Button
                            type="dashed"
                            shape="circle"
                            onClick={() => {
                              setSelectedOvertime(data);
                              setDeleteOvertime(true);
                            }}
                            icon={<DeleteOutlined />}
                            size="small"
                          />
                        </p>
                      </div>
                    </div>
                  ))}
                </>
              )}
              <Divider />

              {/* CALCULATIONS */}
              {logList.ready &&
                logList.data.length > 0 &&
                employeeInfo.ready &&
                employeeInfo.data.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "calc(100% / 3)",
                      }}
                    >
                      <div>
                        Present count:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {activeInfo.active} day(s)
                        </span>
                      </div>
                      <div>
                        Absent count:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {activeInfo.absent} day(s)
                        </span>
                      </div>
                      <div>
                        Late & Undertime:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {lateUnderInfo.late + lateUnderInfo.under}mins ={" "}
                          {
                            employeeInfo.data[0].salary_sched === "daily"
                              ? getDailyLateAndUndertime(
                                  employeeInfo.data[0].daily_amount,
                                  lateUnderInfo.late,
                                  lateUnderInfo.under
                                )
                              : getMonthlyLateAndUndertime(
                                  employeeInfo.data[0].monthly_amount,
                                  employeeInfo.data[0].salary_pay_count,
                                  activeInfo.absent,
                                  activeInfo.active,
                                  lateUnderInfo.late,
                                  lateUnderInfo.under
                                )
                            // parseFloat(
                            //     (employeeInfo.data[0].daily_amount / 8 / 60) *
                            //       (lateUnderInfo.late + lateUnderInfo.under)
                            //   ).toLocaleString(undefined, {
                            //     minimumFractionDigits: 2,
                            //     maximumFractionDigits: 2,
                            //   })
                            // parseFloat(
                            //   (employeeInfo.data[0].monthly_amount /
                            //     employeeInfo.data[0].salary_pay_count /
                            //     (activeInfo.absent + activeInfo.active) /
                            //     8 /
                            //     60) *
                            //     (lateUnderInfo.late + lateUnderInfo.under)
                            // ).toLocaleString(undefined, {
                            //   minimumFractionDigits: 2,
                            //   maximumFractionDigits: 2,
                            // })
                          }
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "calc(100% / 3)",
                      }}
                    >
                      <div>
                        Per Hour:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {
                            employeeInfo.data[0].salary_sched === "daily"
                              ? getDailyPerHour(
                                  employeeInfo.data[0].daily_amount
                                )
                              : getMonthlyPerHour(
                                  employeeInfo.data[0].monthly_amount,
                                  employeeInfo.data[0].salary_pay_count,
                                  activeInfo.absent,
                                  activeInfo.active
                                )
                            // parseFloat(
                            //     employeeInfo.data[0].daily_amount / 8
                            //   ).toLocaleString(undefined, {
                            //     minimumFractionDigits: 2,
                            //     maximumFractionDigits: 2,
                            //   })
                            // parseFloat(
                            //   employeeInfo.data[0].monthly_amount /
                            //     employeeInfo.data[0].salary_pay_count /
                            //     (activeInfo.absent + activeInfo.active) /
                            //     8
                            // ).toLocaleString(undefined, {
                            //   minimumFractionDigits: 2,
                            //   maximumFractionDigits: 2,
                            // })
                          }
                        </span>
                      </div>
                      <div>
                        Per Minute:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {
                            employeeInfo.data[0].salary_sched === "daily"
                              ? getDailyPerMinute(
                                  employeeInfo.data[0].daily_amount
                                )
                              : getMonthlyPerMinute(
                                  employeeInfo.data[0].monthly_amount,
                                  employeeInfo.data[0].salary_pay_count,
                                  activeInfo.absent,
                                  activeInfo.active
                                )
                            // parseFloat(
                            //     employeeInfo.data[0].daily_amount / 8 / 60
                            //   ).toLocaleString(undefined, {
                            //     minimumFractionDigits: 2,
                            //     maximumFractionDigits: 2,
                            //   })
                            // parseFloat(
                            //   employeeInfo.data[0].monthly_amount /
                            //     employeeInfo.data[0].salary_pay_count /
                            //     (activeInfo.absent + activeInfo.active) /
                            //     8 /
                            //     60
                            // ).toLocaleString(undefined, {
                            //   minimumFractionDigits: 2,
                            //   maximumFractionDigits: 2,
                            // })
                          }
                        </span>
                      </div>
                      <div>
                        Basic Pay:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {
                            employeeInfo.data[0].salary_sched === "daily"
                              ? getDailyBasicPay(
                                  employeeInfo.data[0].daily_amount
                                )
                              : getMonthlyBasicPay(
                                  employeeInfo.data[0].monthly_amount,
                                  employeeInfo.data[0].salary_pay_count,
                                  activeInfo.absent,
                                  activeInfo.active
                                )
                            // parseFloat(
                            //     employeeInfo.data[0].daily_amount
                            //   ).toLocaleString(undefined, {
                            //     minimumFractionDigits: 2,
                            //     maximumFractionDigits: 2,
                            //   })
                            // parseFloat(
                            //   employeeInfo.data[0].monthly_amount /
                            //     employeeInfo.data[0].salary_pay_count /
                            //     (activeInfo.absent + activeInfo.active)
                            // ).toLocaleString(undefined, {
                            //   minimumFractionDigits: 2,
                            //   maximumFractionDigits: 2,
                            // })
                          }{" "}
                          = 8hrs work
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "calc(100% / 3)",
                      }}
                    >
                      {deductionList.ready && deductionList.data.length > 0 && (
                        <div>
                          Deductions:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {parseFloat(totalDeduction).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </span>
                        </div>
                      )}

                      {overtimeList.ready && overtimeList.data.length > 0 && (
                        <div>
                          Overtime:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {parseFloat(totalOvertime).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </span>
                        </div>
                      )}

                      <div>
                        Gross Pay:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {employeeInfo.data[0].salary_sched === "daily"
                            ? parseFloat(
                                employeeInfo.data[0].daily_amount *
                                  activeInfo.active
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : parseFloat(
                                (employeeInfo.data[0].monthly_amount /
                                  employeeInfo.data[0].salary_pay_count /
                                  (activeInfo.absent + activeInfo.active)) *
                                  activeInfo.active
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                        </span>
                      </div>
                      <div>
                        Net Pay:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {employeeInfo.data[0].salary_sched === "daily"
                            ? parseFloat(
                                // getDailyNetPay(
                                //   employeeInfo.data[0].daily_amount *
                                //     activeInfo.active,
                                //   employeeInfo.data[0].daily_amount / 8 / 60,
                                //   lateUnderInfo.late + lateUnderInfo.under,
                                //   totalDeduction,
                                //   totalOvertime
                                // )
                                employeeInfo.data[0].daily_amount *
                                  activeInfo.active -
                                  (employeeInfo.data[0].daily_amount / 8 / 60) *
                                    (lateUnderInfo.late + lateUnderInfo.under) -
                                  totalDeduction +
                                  totalOvertime +
                                  getMonthlyPerMinute(
                                    employeeInfo.data[0].monthly_amount,
                                    employeeInfo.data[0].salary_pay_count,
                                    activeInfo.absent,
                                    activeInfo.active
                                  )
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : parseFloat(
                                (employeeInfo.data[0].monthly_amount /
                                  employeeInfo.data[0].salary_pay_count /
                                  (activeInfo.absent + activeInfo.active)) *
                                  activeInfo.active -
                                  (employeeInfo.data[0].monthly_amount /
                                    employeeInfo.data[0].salary_pay_count /
                                    (activeInfo.absent + activeInfo.active) /
                                    8 /
                                    60) *
                                    (lateUnderInfo.late + lateUnderInfo.under) -
                                  totalDeduction +
                                  totalOvertime
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              <div style={{ display: "flex", marginTop: 10 }}>
                <div style={{ flexGrow: 1 }} />
                <Button
                  type="primary"
                  icon={<CheckOutlined />}
                  // size="small"
                  onClick={() => setConfirmAndSave(true)}
                  disabled={!logList.ready || logList.data.length < 1}
                >
                  Confirm & Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <div style={{ border: "1px solid #e5e5e5", borderRadius: 5 }}>
          <div style={{ padding: 10 }}>
            <div style={{ marginBottom: 10 }}>
              <Typography.Title level={4}>Fetch Employee Logs</Typography.Title>
            </div>
            <div>
              <Form
                layout="vertical"
                name="report-filter"
                // initialValues={{ employee: "all" }}
                onFinish={handleGetRecord}
                autoComplete="off"
              >
                <Space
                  direction="vertical"
                  style={{ width: "100%", margin: 0, marginTop: 20 }}
                >
                  <Form.Item
                    name="employee"
                    label="Employee"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select employee"
                      size="large"
                      onChange={(e) => {
                        handleGetEmployeeInfo(e);
                        setSelectedEmployee(e);
                      }}
                      showSearch
                      filterOption={(input, option) => {
                        const optionText = Array.isArray(option.children)
                          ? option.children.join("")
                          : option.children;
                        return (
                          optionText
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        );
                      }}
                    >
                      {employeeList.data.length > 0 &&
                        employeeList.data.map((data, index) => (
                          <Select.Option value={data.user_id} key={index}>
                            {data.firstname} {data.lastname}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="date_from"
                    label="Date From"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"MM/DD/YYYY"}
                      size="large"
                      style={{ width: "100%" }}
                      onChange={(e) =>
                        setSelectedDateFrom(
                          moment(new Date(e)).format("YYYY-MM-DD")
                        )
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="date_to"
                    label="Date To"
                    rules={[
                      {
                        required: true,
                        message: "Required",
                      },
                    ]}
                  >
                    <DatePicker
                      format={"MM/DD/YYYY"}
                      size="large"
                      style={{ width: "100%" }}
                      onChange={(e) =>
                        setSelectedDateTo(
                          moment(new Date(e)).format("YYYY-MM-DD")
                        )
                      }
                    />
                  </Form.Item>
                </Space>

                <Form.Item style={{ marginTop: "20px" }}>
                  <Button
                    type="primary"
                    loading={loading}
                    htmlType="submit"
                    style={{ width: "100%", borderRadius: "20px" }}
                    // onClick={() => console.log("E")}
                  >
                    {loading ? "Loading" : "Get Record"}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </Col>

      {/* LOGS */}
      {addLogDiag && (
        <CreateLogs
          open={addLogDiag}
          close={() => setAddLogDiag(false)}
          employeeInfo={employeeInfo}
          rerun={() => handleGetRecord()}
        />
      )}
      {editLogDiag && (
        <EditLogs
          open={editLogDiag}
          close={() => setEditLogDiag(false)}
          rerun={() => handleGetRecord()}
          selectedData={selectedData}
        />
      )}
      <Modal
        title="Are you sure to delete this log?"
        open={deleteLog}
        onOk={handleLogOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteLog(false)}
        centered
      />

      {/* OVERTIME */}
      {addOvertimeDiag && (
        <CreateOvertime
          open={addOvertimeDiag}
          close={() => setAddOvertimeDiag(false)}
          employeeInfo={employeeInfo}
          rerun={() => handleGetOvertimes()}
          date_from={selectedDateFrom}
          date_to={selectedDateTo}
          perMinute={
            employeeInfo.data[0].salary_sched === "daily"
              ? parseFloat(employeeInfo.data[0].daily_amount / 8 / 60)
              : parseFloat(
                  employeeInfo.data[0].monthly_amount /
                    employeeInfo.data[0].salary_pay_count /
                    (activeInfo.absent + activeInfo.active) /
                    8 /
                    60
                )
          }
          perHour={
            employeeInfo.data[0].salary_sched === "daily"
              ? parseFloat(employeeInfo.data[0].daily_amount / 8)
              : parseFloat(
                  employeeInfo.data[0].monthly_amount /
                    employeeInfo.data[0].salary_pay_count /
                    (activeInfo.absent + activeInfo.active) /
                    8
                )
          }
          // selectedData={selectedData}
        />
      )}
      {editOvertimeDiag && (
        <EditOvertime
          open={editOvertimeDiag}
          close={() => setEditOvertimeDiag(false)}
          rerun={() => handleGetOvertimes()}
          selectedData={selectedOvertime}
        />
      )}
      <Modal
        title="Are you sure to delete this overtime?"
        open={deleteOvertime}
        onOk={handleOvertimeOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteOvertime(false)}
        centered
      />

      {/* ADD GOVT CONTRIBUTION */}
      <Modal
        title="Are you sure to add govt contribution?"
        open={addGovtContribDiag}
        onOk={handleAddGovtContribution}
        confirmLoading={confirmLoading}
        onCancel={() => setAddGovtContribDiag(false)}
        centered
      />

      {/* DEDUCTION */}
      {addDeductionDiag && (
        <CreateDeduction
          open={addDeductionDiag}
          close={() => setAddDeductionDiag(false)}
          employeeInfo={employeeInfo}
          rerun={() => handleGetDeductions()}
          date_from={selectedDateFrom}
          date_to={selectedDateTo}
          // selectedData={selectedData}
        />
      )}
      {editDeductionDiag && (
        <EditDeduction
          open={editDeductionDiag}
          close={() => setEditDeductionDiag(false)}
          rerun={() => handleGetDeductions()}
          selectedData={selectedDeduction}
        />
      )}
      <Modal
        title="Are you sure to delete this deduction?"
        open={deleteDeduction}
        onOk={handleDeductionOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDeduction(false)}
        centered
      />

      {/* SAVE AND CONFIRM PAYROLL */}
      <Modal
        title="Are you sure to confirm and save it to payroll?"
        open={confirmAndSave}
        onOk={handleConfirmAndSaveOk}
        confirmLoading={confirmLoading}
        onCancel={() => setConfirmAndSave(false)}
        centered
      />
    </Row>
  );
};

export default CreatePayroll;
